import { getSentryClient } from '@atlassian/mpac-utils';
import tap from 'redux-tap';
import { RECEIVE_FEATURE_FLAGS, RECEIVE_HOST_INFO } from '../actions/Configuration';
const isHostInfoOrFeatureFlagsReceived = action => action.type === RECEIVE_HOST_INFO || action.type === RECEIVE_FEATURE_FLAGS;
const setSentryScope = (_, action) => {
  switch (action.type) {
    case RECEIVE_HOST_INFO:
      {
        var _getSentryClient;
        const hostInfo = action.hostInfo;
        (_getSentryClient = getSentryClient()) === null || _getSentryClient === void 0 ? void 0 : _getSentryClient.configureScope(scope => {
          scope.setTag('product', hostInfo.product);
          scope.setTag('contextId', hostInfo.globalContext.id);
        });
        break;
      }
    case RECEIVE_FEATURE_FLAGS:
      {
        var _getSentryClient2;
        const featureFlags = action.featureFlags.getAllFlags().toJS();
        (_getSentryClient2 = getSentryClient()) === null || _getSentryClient2 === void 0 ? void 0 : _getSentryClient2.configureScope(scope => {
          Object.entries(featureFlags).forEach(_ref => {
            let [flagName, flagValue] = _ref;
            return scope.setTag("ff-".concat(flagName), flagValue);
          });
        });
        break;
      }
  }
};
const SentryMiddleware = tap(isHostInfoOrFeatureFlagsReceived, setSentryScope);
export default SentryMiddleware;